export default "__VITE_ASSET__BNF9Z7I$__"